import { render, staticRenderFns } from "./className.vue?vue&type=template&id=dfae81ea&scoped=true"
import script from "./className.vue?vue&type=script&lang=js"
export * from "./className.vue?vue&type=script&lang=js"
import style0 from "./className.vue?vue&type=style&index=0&id=dfae81ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfae81ea",
  null
  
)

export default component.exports